import React from "react";
import PersonForm from "../Personnel/PersonForm";
import PersonView from "../Personnel/PersonView";

/**
 * Master Data Add/Edit/View screens mirroring the production MasterData /
 * geofenceArea / pointsOfIntrest / parkingSlot pages.
 */

// ---- Holidays ----
const holidayFields = [
  { label: "Holiday Name", placeholder: "Enter Holiday Name" },
  { label: "Date", placeholder: "Select Date" },
  { label: "Description", placeholder: "Enter Description", multiline: true },
];
export const AddHolidays = () => <PersonForm title="Add Holiday" fields={holidayFields} />;
export const EditHolidays = () => (
  <PersonForm title="Edit Holiday" fields={holidayFields} submitLabel="Update" />
);

// ---- Vacation ----
const vacationFields = [
  { label: "Vacation Name", placeholder: "Enter Vacation Name" },
  { label: "From Date", placeholder: "Select Date" },
  { label: "To Date", placeholder: "Select Date" },
  { label: "Description", placeholder: "Enter Description", multiline: true },
];
export const AddVacation = () => <PersonForm title="Add Vacation" fields={vacationFields} />;
export const EditVacation = () => (
  <PersonForm title="Edit Vacation" fields={vacationFields} submitLabel="Update" />
);

// ---- Geofence ----
const geofenceFields = [
  { label: "Location Name", placeholder: "Enter Location Name..." },
  { label: "Location Address", placeholder: "Enter Location Address" },
  { label: "Address", placeholder: "Enter Address" },
  { label: "City / State", placeholder: "Enter City / State..." },
  { label: "Landmark", placeholder: "Enter Landmark ..." },
  { label: "Geofence Type", placeholder: "Select Type (Circle / Polygon)" },
  { label: "Radius (m)", placeholder: "Enter Radius" },
];
export const AddGeofenceArea = () => <PersonForm title="Add Geofence Area" fields={geofenceFields} />;
export const EditGeofenceArea = () => (
  <PersonForm title="Edit Geofence Area" fields={geofenceFields} submitLabel="Update" />
);

// ---- Point of Interest ----
const poiFields = [
  { label: "Location Name", placeholder: "Enter Location Name..." },
  { label: "Location Address", placeholder: "Enter Location Address" },
  { label: "Type", placeholder: "Select Type" },
];
export const AddPointOfInterest = () => (
  <PersonForm title="Add Point Of Interest" fields={poiFields} />
);

// ---- Parking ----
const parkingFields = [
  { label: "Station Name", placeholder: "Enter Station Name..." },
  { label: "Station Code", placeholder: "Enter a Station Code..." },
  { label: "Parking Capacity", placeholder: "Enter Parking Capacity." },
  { label: "Station Address", placeholder: "Enter Station Address.", multiline: true },
];
export const EditParkingSlot = () => (
  <PersonForm title="Edit Parking Slot" fields={parkingFields} submitLabel="Update" />
);

// ---- Vehicle Group ----
const groupFields = [
  { label: "Group Name", placeholder: "Enter Group Name..." },
  { label: "Fuel Type", placeholder: "Select Fuel Type..." },
  { label: "Vehicle Group", placeholder: "Select Vehicle Group ..." },
];
export const AddVehicleGroup = () => <PersonForm title="Add Vehicle Group" fields={groupFields} />;
export const EditVehicleGroup = () => (
  <PersonForm title="Edit Vehicle Group" fields={groupFields} submitLabel="Update" />
);

// ---- Vehicle Category ----
export const AddVehicleCategory = () => (
  <PersonForm
    title="Add Vehicle Category"
    fields={[
      { label: "Category Name", placeholder: "Enter Category Name" },
      { label: "Description", placeholder: "Enter Description", multiline: true },
    ]}
  />
);

// ---- Vehicle (Edit / Details / Sync) ----
const vehicleFields = [
  { label: "Vehicle Name", placeholder: "Enter Vehicle Name" },
  { label: "Vehicle Number", placeholder: "Enter Vehicle Number" },
  { label: "IMEI No", placeholder: "Enter IMEI Number" },
  { label: "Vehicle Type", placeholder: "Select Vehicle Type" },
  { label: "Vehicle Category", placeholder: "Select Vehicle Category" },
  { label: "Transportation Type", placeholder: "Select Transportation Type" },
  { label: "Vehicle Capacity / Passenger", placeholder: "Enter Capacity" },
  { label: "Driver Name", placeholder: "Select Driver" },
];
export const EditVehicle = () => (
  <PersonForm title="Edit Vehicle" fields={vehicleFields} submitLabel="Update" />
);
export const VehicleDetails = () => (
  <PersonView
    title="Vehicle Details"
    name="Utility CAB"
    cards={[
      {
        heading: "Vehicle Information",
        rows: [
          { label: "Vehicle Number", value: "MH-12-5022" },
          { label: "Driver Name", value: "Mr. John Doe" },
          { label: "IMEI No", value: "1234567894561230", full: true },
          { label: "Vehicle Type", value: "Car" },
          { label: "Transportation Type", value: "Passenger" },
          { label: "Vehicle Capacity", value: "60" },
        ],
      },
    ]}
  />
);
export const NewSyncRequest = () => (
  <PersonForm
    title="New Sync Request"
    submitLabel="Sync"
    fields={[
      { label: "Vehicle", placeholder: "Select Vehicle" },
      { label: "Device IMEI", placeholder: "Enter Device IMEI" },
      { label: "Sync Type", placeholder: "Select Sync Type" },
    ]}
  />
);
export const Overspeed = () => (
  <PersonForm
    title="Overspeed"
    submitLabel="Save"
    fields={[
      { label: "Vehicle", placeholder: "Select Vehicle" },
      { label: "Speed Limit (km/h)", placeholder: "Enter Speed Limit" },
      { label: "Alert Type", placeholder: "Select Alert Type" },
    ]}
  />
);
